.cp{display:inline-flex;}